import Login from '../apis/login';
import Profile from '../apis/profile';
import Logout from '../apis/logout';
import SignUp from '../apis/signup';

const state = {};
const actions = {
    checkMobileNumber({ commit }) {
        return Login.CheckMobileNumber({
            vendor_id: this.$auth.getVendorId(),
            user_role: '1',
            mobile_number: '',
            is_langauge: this.$store.state.lang.locale,
        }).then(response => {
            commit('checkMobileNumber', response.data);
        })
    },

    checkLogin({ commit }, data) {
        return Login.CheckLogin(data).then(response => {
            if (response.data.code == 200) {
                window.axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.user_details.token}`;
                return response.data;
            }
            return response.data;
        })
    },

    checkMobileLogin({ commit }, data) {
        return Login.getCustomerDetailsMobile(data).then(response => {
            if (response.data.code == 200) {
                window.axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.user_details.token}`;
                return response.data;
            }
            return response.data;
        })
    },

    checkLogout({ commit }, data) {
        return Logout.CheckLogout(data).then(response => {
            if (response.data.code == 200) {
                delete window.axios.defaults.headers.common["Authorization"];
                return response.data;
            }
            return response.data;
        })
    },

    changePassword({ commit }, data) {
        return Profile.ChangePassword(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
                //commit('changePassword', response.data)
            }
            return response.data;
        })
    },

    updateSignUp({ commit }, data) {
        return SignUp.checkSignUp(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    updateUserDetails({ commit }, data) {
        return Profile.UpdateProfile(data).then(response => {
            if (response.data.code == 200) {
                //commit('updateUserDetails', response.data.user_details)
                return response.data;
            }
            return response.data;
        })
    },

    getUserDetailsData({ commit }, data) {
        return Login.getUserDetails(data).then(response => {
            if (response.data.code == 200) {
                //commit('getUserData', response.data);
                return response.data;
            }
            return response.data;
        })
    },

    getUserSupportChat({ commit }, data) {
        return Profile.getMessages(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    sendSupportMessages({ commit }, data) {
        return Profile.sendMessages(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },

    customerDefaultMessageList({ commit }, data) {
        return Profile.customerDefaultMessage(data).then(response => {
            if (response.data.code == 200) {
                return response.data;
            }
            return response.data;
        })
    },    
};
const mutations = {
    // getUserData(state, userDetails) {
    //     state.userDetails = userDetails
    // }
};
const getters = {}

export const user = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};